import React from 'react';
import HireMe from './HireMe';
import { Link } from 'react-router-dom';


const Header = () => {
  return (
    <div className="header" id="header">
      <div className="container">
        <a href="\" className="logo"><img className="logo-img" src="imgs/Mohamed abi.png" alt="" /></a>
        <ul className="main-nav">
          <li><a href="/#projects">Projects</a></li>
          <li><a href="/#tools">Tools</a></li>
          <li><a href="/#pricing">About us</a></li>
          <li><Link to="/certifications">certifications</Link></li>
          <HireMe/>
        </ul>
      </div>
    </div>
  );
};

export default Header;
